import { useRouteMatch } from 'react-router-dom'
import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { getCourseItem } from '../../../utils/request'

// 本页面作为跳转课程中转页
const CourseJump = ({history}) => {
    const match = useRouteMatch()
    const getCourseData = (id) => {
        return getCourseItem(id)
    }
    useEffect(() => {
        const id = match.params.id
        getCourseData(id).then(res => {
            if (res.status === 200) {
                // 系列课
                if (res.data.is_series) {
                    const units = res.data.units
                    const target = units?.[0]
                    const unit_id = target?.id
                    if (unit_id) {
                        history.replace(`/course/${id}/${unit_id}/`)
                    }
                // 非系列课
                } else {
                    history.replace(`/course/${id}/0`)
                }
            }
        })
    }, [])
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1,
            marginTop: '25vh'
        }}>
            <Spin size="large" tip="页面跳转中..." />
        </div>
    )
}

export default CourseJump